<template lang="pug">
  div(ref="chartTimelineGraph")
    svg( xmlns="http://www.w3.org/2000/svg" :height="componentHeight" width="100%"   transform="scale(1,-1)")
      rect(v-for="(item,index) in avlTimelineData" v-if="item" :key="index" :x="(index*barWidth)-(barWidth*0.5)" y="0"  :width="barWidth" :height="item.s*(componentHeight/maxSpeed)" style="fill:gray;")
      line(:x1="getPosX" y1="0" :x2="getPosX" :y2="componentHeight"  style="stroke:rgb(255,0,0);stroke-width:1")
</template>

<script>
export default {
  data:()=>({
    chartWidth:10,
    barWidth:7.6,
    maxSpeed: 100,
    componentHeight:100
  }),

  watch:{
    avlTimelineData:function(avlData){
        this.chartWidth = this.$refs.chartTimelineGraph.getBoundingClientRect().width
        this.barWidth = this.chartWidth/avlData.length
        this.maxSpeed = this.$store.getters["vehicles/devices/getCurrentDevice"].max_speed;
    }
  },

  computed:{
    avlTimelineData: function(){
     return this.$store.getters['timeline/getAvlTimeline']
    },
    getPosX:function(){
      return this.chartWidth*(this.$store.state.timeline.percentage/100.0);
    },

  },

  mounted() {
    this.chartWidth = this.$refs.chartTimelineGraph.getBoundingClientRect().width
    this.maxSpeed = this.$store.getters["vehicles/devices/getCurrentDevice"].max_speed;
    console.log(this.maxSpeed)

    let noItems = this.$store.getters["timeline/getAvlTimeline"].length
    console.log(`WIdth is ${this.chartWidth}  counts:${noItems}  calc:${this.chartWidth/noItems}` )

  }
}
</script>

<style scoped lang="stylus">

</style>